<template>
  <DxCheckBox
    :on-value-changed="onSelectionChanged"
    :element-attr="checkBoxAttributes"
    :value="value"
    :readOnly="readOnly"
    :ref="'grid-cb-' + refKey"
    :disabled="disabled"
  >
  </DxCheckBox>
</template>
<script>
import DxCheckBox from "devextreme-vue/check-box";

export default {
  components: {
    DxCheckBox,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    value: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    refKey: {
      type: String,
      default: "grid-cb",
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkBoxAttributes: {
        id: "grid-check-box",
        class: "grid-check-box-class",
      },
    };
  },
  created() {},
  computed: {
    getLabelText() {
      return this.labelText;
    },
  },
  methods: {
    onSelectionChanged(e) {
      this.valueChangeCallBack(e, this.data);
    },
    initialized(e) {
      if (this.defaultValue) {
        e.component.beginUpdate();
        // e.component.option("value", this.defaultValue);
        e.component.endUpdate();
      }
    },
    getSeletcAllRef() {
      return this.$refs["grid-cb-" + this.refKey];
    },
  },
};
</script>

<style lang="scss">
.grid-check-box-class {
  .dx-checkbox-container .dx-checkbox-text {
    color: rgba(117, 117, 117, 0.87);
    font-size: 12px;
    text-align: end;
    padding-left: 5px;
  }
}
</style>
